<div class="cart-control-form-configurations">
  <div class="content" [formGroup]="configurationsGroup">
    <!-- Configurations card — button settings only -->
    <div class="section">
      <pdq-heading element="h5">Configurations</pdq-heading>
      <div class="controls-wrapper">
        <span class="section-title">Button settings</span>
        <div class="button-controls-row">
          <pdq-input
            label="Button Label"
            [formControl]="configurationsGroup.get('buttonLabel')"
            [invalid]="configurationsGroup.get('buttonLabel')?.errors?.required"
            invalidMsg="Button Label is required"></pdq-input>
          <pdq-dropdown
            title="Button Appearance"
            formControlName="buttonAppearance"
            [defaultOption]="
              configurationsGroup.get('buttonAppearance').value | primitiveDropdownOptionPipe: appearanceToDisplayText
            "
            [options]="Appearances | primitiveDropdownOptionsPipe: appearanceToDisplayText"></pdq-dropdown>
        </div>
      </div>
    </div>

    <!-- Actions card — global "Allow customers to" + rule-based Exceptions -->
    <div class="section">
      <pdq-heading element="h5">Actions</pdq-heading>
      <div class="controls-wrapper">
        <span class="section-title">Allow customers to:</span>
        <div class="option">
          <pdq-checkbox
            [formControl]="configurationsGroup.get('changeVariant')"
            label="Change Variant"
            labelSize="medium"></pdq-checkbox>
          <div class="checkbox-description">
            <span class="description"
              >Allows customers to choose a different in-stock variant directly from checkout.</span
            >
          </div>
        </div>
        <div class="option">
          <pdq-checkbox
            [formControl]="configurationsGroup.get('editQuantity')"
            label="Edit Quantity"
            labelSize="medium"></pdq-checkbox>
          <div class="checkbox-description">
            <span class="description"
              >Allows customers to increase or decrease the item quantity from within checkout.</span
            >
          </div>
        </div>
        <div class="option">
          <pdq-checkbox
            [formControl]="configurationsGroup.get('removeItems')"
            label="Remove Items"
            labelSize="medium"></pdq-checkbox>
          <div class="checkbox-description">
            <span class="description">Allows customers to remove this item from their checkout.</span>
          </div>
        </div>
        <div class="option">
          <pdq-checkbox
            [formControl]="configurationsGroup.get('showSubscriptionSelector')"
            label="Show Subscription Selector"
            labelSize="medium"></pdq-checkbox>
          <div class="checkbox-description">
            <span class="description"
              >Enables customers to update their subscription plan. (Shown only for products that support
              subscriptions)</span
            >
          </div>
          @if (configurationsGroup.controls.showSubscriptionSelector.value) {
            <cart-control-subscription-selector
              [typeControl]="configurationsGroup.controls.subscriptionSelectorType"
              [upgradeButtonLabelControl]="configurationsGroup.controls.upgradeButtonLabel"
              [upgradeButtonAppearanceControl]="configurationsGroup.controls.upgradeButtonAppearance"
              [upgradeButtonTextColorControl]="configurationsGroup.controls.upgradeButtonTextColor"
              [upgradeButtonLabelInvalid]="
                configurationsGroup.controls.upgradeButtonLabel.errors?.required
              "></cart-control-subscription-selector>
          }
        </div>
        <cart-control-form-exceptions
          [configurationsGroup]="configurationsGroup"
          [shopCurrencySymbol]="shopCurrencySymbol"></cart-control-form-exceptions>
      </div>
    </div>
  </div>
</div>
